const keys = {
  policyPages: {
    activePolicies: {
      title: 'Hello {{0}},',
      subtitle:
        'Manage and request changes to your active policies here. It may take up to 48 hours for a new policy to be displayed. For questions or help, visit <0>our Help Center</0>.',
      tabs: {
        activePolicies: 'Active Policies',
        notifications: 'Notifications',
      },
      empty: 'No active policies',
    },
    modifyPolicy: {
      title: 'Modify Policy',
      subtitle: 'Choose an option below, follow the steps and we will take care of the rest.',
    },
    documents: {
      title: 'Documents',
      subtitle: 'Please note that it may take up to 48 hours for new policy documents to be displayed.',
      failedToDownload: "Couldn't download document, try again later or <0>contact support</0>.",
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
